import { useEffect, useState } from "react";

export const useOrigin = () => {
  const [origin, setOrigin] = useState(process.env.NEXT_PUBLIC_URL);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setOrigin(window.location.origin);
  }, []);

  return origin;
};
